import { ReactNode } from "react"

import { FloatingTooltip } from "../../../../../components/base/overlay/FloatingTooltip"
import {
  Combobox,
  ComboboxProps,
  DefaultEmptyState,
  DefaultRow,
} from "../../../../../components/composite/combobox/Combobox"
import { useCombobox } from "../../../../../components/composite/combobox/useCombobox"

export interface FilteredComboboxProps<T> {
  items: T[]
  tooltipExtractor?: (item: T) => ReactNode
  keyExtractor: (item: T) => string
  valueExtractor: (item: T) => string
  accessoryExtractor?: (item: T) => ReactNode
  onSelect: (item: T) => void
  comboboxProps?: Partial<ComboboxProps<T>>
  onChangeQuery?: (query: string) => void
}

export function FilteredCombobox<T>({
  items,
  tooltipExtractor,
  keyExtractor,
  valueExtractor,
  accessoryExtractor,
  onSelect,
  comboboxProps,
  onChangeQuery,
}: FilteredComboboxProps<T>) {
  const useComboboxRes = useCombobox<T>({
    items,
    keyExtractor,
    valueExtractor,
    onSelect,
    autoFilter: true,
    onChangeQuery,
  })

  return (
    <Combobox
      useComboboxRes={useComboboxRes}
      renderItem={(item, isHighlighted) => (
        <FloatingTooltip
          content={tooltipExtractor?.(item)}
          placement="right-start"
          offsetDistance={8}
          portal={{ renderTo: "document" }}
          className="max-w-75"
          trigger={
            <DefaultRow
              item={item}
              isHighlighted={isHighlighted}
              valueExtractor={valueExtractor}
              accessoryExtractor={accessoryExtractor}
            />
          }
          isDisabled={!tooltipExtractor?.(item)}
        />
      )}
      keyExtractor={(item) => keyExtractor(item)}
      renderEmptyState={DefaultEmptyState}
      {...comboboxProps}
    />
  )
}
